import React, {Component} from 'react'
import PropTypes from 'prop-types'

export default class PageInterface extends Component {
  componentDidMount () {
    const {
      onClosePage
    } = this.props

    document.addEventListener('keyup', (e) => {
      switch (e.keyCode) {
        case 27: // ESC
          if (!document.body.classList.contains('medium-zoom--opened')) {
            onClosePage()
          }
          break
        default:
          break
      }
    })
  }
  render () {
    const {
      className,
      pageTitle,
      onTogglePage
    } = this.props

    return (
      <div className={className}>
        <div className='close' onClick={() => { onTogglePage() }}>
        </div>
        <div className="pagetitle">{pageTitle}</div>
      </div>
    )
  }
}

PageInterface.defaultProps = {
  className: 'page-interface',
  pageTitle: 'Loading'
}

PageInterface.propTypes = {
  className: PropTypes.string,
  onTogglePage: PropTypes.func,
  onClosePage: PropTypes.func,
  pageTitle: PropTypes.string
}
